import React, { Component, PropTypes } from "react"
import { Form, Table, Row, Input, message } from "antd"
import Moment from "moment"
import { observer, inject } from "mobx-react"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import folderIcon from "app/styles/images/sp/folder.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { withRouter } from 'react-router-dom'
import queryString from "query-string"

const FormItem = Form.Item
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
}

const ObserverFamilyName = observer(({ record, _this, store }) => {
  const { editedHistory } = _this.state
  const { list: { queryMap: { keywords } } } = store
  const tip = (
    <MaterialTip
      overlayClassName="ellipsis-tip"
      title={record.name}
    >
      <Highlighter
        highlightClassName="lightlight"
        highlightStyle={{ fontWeight: "normal" }}
        searchWords={highlightable(record.name, keywords) ? [record.name] : []}
        textToHighlight={record.name}
      />
    </MaterialTip>
  )

  return (
    record.hasHistory
      ? (
        <Row
          onClick={() => _this.openDetail(record)}
          className="family-name cursor-p"
          type="flex"
          justify="start"
          align="middle"
        >
          <img className="folder-icon" src={folderIcon} alt="" />
          <WarningTip
            type="warningTip"
            text={tip}
            justify="start"
            mainKeys={["versionNum", "name", "createTime"]}
            historyData={editedHistory}
            onVisibleChange={(visible) => _this.toggleHistory(visible, record)}
          />
        </Row>
      )
      : (
        <div className="cursor-p" onClick={() => _this.openDetail(record)}>
          <img className="folder-icon" src={folderIcon} alt="" />
          <Highlighter
            highlightClassName="lightlight"
            highlightStyle={{ fontWeight: "normal" }}
            searchWords={highlightable(record.name, keywords) ? [record.name] : []}
            textToHighlight={record.name}
          />
        </div>
      )
  )
})

@inject("auth") @observer
class Index extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      dataSingle: {},
      editedHistory: [],
      name: "",
    }

    this.columns = []
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps

    if (nextLocation.search !== location.search) {
      if (nextLocation.search) {
        this.loadLimitedData(queryString.parse(nextLocation.search))
      } else {
        this.loadAllData()
      }
    }
  }

  componentDidMount() {
    let { location } = this.props
    if (location.search) {
      this.loadLimitedData(queryString.parse(location.search))
    } else {
      this.loadAllData()
    }
  }

  loadAllData() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  loadLimitedData(queryObj) {
    this.props.store.list.filterData(queryObj)
  }

  showEditModal = (record) => {
    this.setState({
      showEditModal: true,
      dataSingle: record,
      name: record.name,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  changeHandle = (e, field) => {
    this.setState({
      name: e.target.value
    })
  }

  updateFamily = (familyId) => {
    const { store: { updateFamily } } = this.props
    const { name, dataSingle } = this.state

    if (!(name || " ").trim()) {
      message.warning("家系名不能为空")
      return
    }

    if (dataSingle.name === name) {
      message.warning("新家系名与旧家系名相同，未修改")
      return
    }

    updateFamily(familyId, name)
      .then(
        res => {
          this.setState({
            showEditModal: false
          })
          dataSingle.name = name
          dataSingle.hasHistory = true
          message.success("编辑保存成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  toggleHistory = (visible, record) => {
    if (visible) {
      // 获取数据
      const { getHistory } = this.props.store
      getHistory(record.id)
        .then(res => {
          this.setState({
            editedHistory: res
          })
        })
    } else {
      //清空拿到的数据
      this.setState({
        editedHistory: []
      })
    }
  }

  openDetail = (record) => {
    const { match, history } = this.props
    history.push(`${match.url}/${record.id}`)
  }

  render() {
    let {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props
    const { dataSingle, name, editedHistory } = this.state

    this.columns = [
      {
        title: (
          <div className="ta-l">家系名称</div>
        ),
        dataIndex: "name",
        render: (title, record, index) => {
          return (
            <ObserverFamilyName
              record={record}
              store={this.props.store}
              editedHistory={editedHistory}
              _this={this}
            />
          )
        }
      }, {
        title: (
          <div className="ta-c">数据数量</div>
        ),
        dataIndex: "dataCount",
        render: (text, record) => {
          return (
            <div className="ta-c">{text}条</div>
          )
        }
      }, {
        title: (
          <div className="ta-r">合计数据大小</div>
        ),
        dataIndex: "dataSize",
        render: text => {
          return text ? <div className="ta-r">{(text / 1024 / 1024).toFixed(2)}MB</div> : ""
        }
      }, {
        title: (
          <div className="ta-c time-title">上传时间</div>
        ),
        dataIndex: "createTime",
        sorter: (a, b) => new Date(a.createTime) - new Date(b.createTime),
        render: text => {
          return text ? <div className="ta-c">{Moment(text).format("YYYY-MM-DD HH:mm:ss")}</div> : ""
        }
      }, {
        title: "操作",
        dataIndex: "oprator",
        width: 104,
        render: (text, record) => {
          return (
            <Row className="table-oprator" type="flex" justify="center" align="middle">
              <img
                title="修改"
                src={editAbleIcon}
                alt=""
                onClick={() => this.showEditModal(record)}
              />
            </Row>
          )
        }
      }
    ]
    return (
      <div>
        <div className="wrapper-box">
          <Table
            className="pgd-datamanage-table"
            columns={this.columns}
            rowKey={record => record.id}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          />
          <MaterialModal
            title="家系编辑"
            buttonText="保存"
            visible={this.state.showEditModal}
            action={() => this.updateFamily(dataSingle.id)}
            buttonType="primary">
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("showEditModal")}
            />
            <Form>
              <FormItem {...formItemLayout} label="家系名称">
                <Input value={name}
                  onChange={(e) => this.changeHandle(e, "name")}
                />
              </FormItem>
            </Form>
          </MaterialModal>
        </div>
      </div>
    )
  }
}

export default withRouter(Index)



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/data_manage/containers/DataTable.js